export default "__VITE_ASSET__GuQWbYYb__"